(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-pino-navigation"] && !Shopify.designMode) return;
  try {
    const pinoHeaderBreakpoint = window.matchMedia('(min-width: 640px)');
  pinoHeaderBreakpoint.addEventListener('change', (event) => {
    const header = document.getElementById('PinoRefinedHeader');
    if (!header) return;
    if (event.matches) {
      const drawer = header.querySelector('header-drawer');
      if (drawer?.querySelector(':scope > details[open]') && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer();
    } else {
      header.querySelectorAll('.pino-header-preferences localization-form').forEach((form) => form.hidePanel?.());
      header.querySelectorAll('[data-pino-refined-navigation] > details, .pino-header-preferences').forEach((details) => { details.open = false; });
    }
  });
  document.querySelectorAll('[data-pino-refined-navigation]').forEach((navigation) => {
    const groups = [...navigation.querySelectorAll('details')];
    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (group.open) {
          groups.forEach((other) => { if (other !== group) other.open = false; });
          if (navigation.classList.contains('pino-refined-nav--header')) {
            const preferences = document.querySelector('#PinoRefinedHeader .pino-header-preferences');
            if (preferences) preferences.open = false;
          }
        }
      });
      group.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && group.open) {
          group.open = false;
          group.querySelector('summary').focus();
          event.preventDefault();
        }
      });
    });
    document.addEventListener('pointerdown', (event) => {
      if (!navigation.contains(event.target)) groups.forEach((group) => { group.open = false; });
    });
  });
  const pinoPreferences = document.querySelector('#PinoRefinedHeader .pino-header-preferences');
  if (pinoPreferences) {
    const closePinoPreferences = () => {
      pinoPreferences.querySelectorAll('localization-form').forEach((form) => form.hidePanel?.());
      pinoPreferences.open = false;
    };
    document.addEventListener('pointerdown', (event) => {
      if (pinoPreferences.open && !pinoPreferences.contains(event.target)) closePinoPreferences();
    });
    pinoPreferences.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || pinoPreferences.querySelector('[aria-expanded="true"]')) return;
      closePinoPreferences();
      pinoPreferences.querySelector('summary').focus();
      event.preventDefault();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
